import { apiPath } from "./baseUrl";

const UPLOAD_ROUTES = {
  gpx: { tablet: "uploadGPX", server: "uploadGPXOnServer" },
  txt: { tablet: "uploadTxt", server: "uploadTxtOnServer" },
  icon: { tablet: "uploadIcon", server: "uploadIconOnServer" },
  image: { tablet: "uploadImage", server: "uploadImageOnServer" },
  video: { tablet: "uploadVideo", server: "uploadVideoOnServer" },
  audio: { tablet: "uploadAudio", server: "uploadAudioOnServer" },
  imageQuiz: {
    tablet: "uploadImageQuiz",
    server: "uploadImageQuizOnServer",
  },
};

const requiredSegment = (value, label) => {
  if (typeof value !== "string" || value.trim() === "") {
    throw new Error(`${label} requis.`);
  }
  return encodeURIComponent(value);
};

const projectRoot = (projectId) =>
  apiPath(`/project/${requiredSegment(projectId, "Identifiant du projet")}`);

export const projectFilesApi = {
  tabletStatus: (projectId) => `${projectRoot(projectId)}/checkTabletConnection`,
  upload: (projectId, fileType, { toTablet = false } = {}) => {
    const route = UPLOAD_ROUTES[fileType];
    if (!route) throw new Error("Type de fichier inconnu.");
    return `${projectRoot(projectId)}/${toTablet ? route.tablet : route.server}`;
  },
  storeGpx: (projectId) => `${projectRoot(projectId)}/download`,
  list: (projectId) => `${projectRoot(projectId)}/files`,
  download: (projectId, fileName) =>
    `${projectRoot(projectId)}/files/${requiredSegment(fileName, "Nom du fichier")}`,
};

export default projectFilesApi;
